var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myScrollbar",staticClass:"warp-scroll"},[_c('div',{staticClass:"scroll"},[_vm._t("default")],2),_vm._v(" "),(_vm.visible)?_c('div',{staticClass:"scroll-backtop",on:{"click":_vm.totop}},[_c('i',{staticClass:"el-icon-caret-top"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc3e473","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IrSlider.vue
// module id = null
// module chunks = 